export interface Subscription {
  team_name: string,
  credit_card_update_url: string,
  next_payment: string,
  recipients: string[],
  invoice_id?: string,
  quantity?: number,
  payment_method?: BillingPaymentMethod
}

export interface BillingPaymentMethod {
  type: string,
  exp_month: number,
  exp_year: number,
  brand: string,
  last4: string
}

export interface MonthlyBillableAmount {
teams: SubscriptionTeam[],
total_active_members_count: number,
duplicated_members_count: number,
unit_price: number,
vat_rate: number,
vat_amount: number,
total_amount: number,
}

export interface SubscriptionTeam {
  id: string,
  active_members_count: number,
  already_subscribed: boolean
  name: string
}

export type Currency = {
  id: 'EUR' | 'USD' | 'GBP' | 'AUD' | 'CAD',
  display: string
};

export const EuroCurrency: Currency = {
  id: 'EUR',
  display: '€'
}

export const USDCurrency: Currency = {
  id: 'USD',
  display: '$'
}

export const GBPCurrency: Currency = {
  id: 'GBP',
  display: '£'
}

export const AUDCurrency: Currency = {
  id: 'AUD',
  display: 'AU$'
}

export const CADCurrency: Currency = {
  id: 'CAD',
  display: 'CA$'
}

export interface YearlySubscription {
  currentQuantity: number;
  maxQuantity: number;
  subscription_end: Date;
  contact?: string;
}

export interface LicenceUsageWithDiff {
  count: number;
  diff: number;
}

export interface TeamLicenceDetails {
  id: string;
  name: string;
  creationDate: Date;
  creator: string;
  selectedMonthUsage: number,
  currentMonthUsage: LicenceUsageWithDiff
}

export interface YearlySubscriptionDetailsByTeamDTO {
  months: Date[];
  teams: TeamLicenceDetails[];
  totalSelectedMonth: number;
  totalCurrentMonth: LicenceUsageWithDiff;
}
